// 键名建议使用语义化标识（如 "common.welcome" 表示通用模块的"欢迎"）
export default {
    common: {
      welcome: "欢迎使用系统",
      login: "登录",
      logout: "退出",
      language: "语言"
    },
    store: {
      name: "门店名称",
      address: "门店地址",
      phone: "联系电话"
    }
  };